/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/IsEqual.ts
 * @create:      2025-06-26 13:26:49.866
 * @modify:      2025-07-11 21:19:12.828
 * @version:     6.0.0
 * @times:       6
 * @lines:       55
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Compares two optional strings for equality, with an option to ignore case sensitivity.
 *
 * @param a - The first string to compare. Can be `undefined`.
 * @param b - The second string to compare. Can be `undefined`.
 * @param ignoreCase - Whether to ignore case when comparing the strings. Defaults to `true`.
 * @returns `true` if both strings are equal (considering case sensitivity based on `ignoreCase`), or if both are `undefined`. Otherwise, returns `false`.
 * 
 * @since 2.0.13
 * @version 2021-03-18
 */
export function IsEqual(a?: string, b?: string, ignoreCase = true) {
    if (a === undefined || b === undefined) {
        return a === b;
    }

    if (ignoreCase) {
        return a.toLowerCase() === b.toLowerCase();
    }

    return a === b;
}
